import { render, staticRenderFns } from "./DataAuthEdit.vue?vue&type=template&id=ad07d95a&scoped=true&"
import script from "./DataAuthEdit.vue?vue&type=script&lang=js&"
export * from "./DataAuthEdit.vue?vue&type=script&lang=js&"
import style0 from "./DataAuthEdit.vue?vue&type=style&index=0&id=ad07d95a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad07d95a",
  null
  
)

export default component.exports